import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-[#2A2825] text-[#8a7a6a] border-t border-[#413d38]">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
      <div className="grid md:grid-cols-3 gap-10 mb-12">
        <div>
          <div className="flex items-end gap-2">
            <span className="font-script text-4xl text-[#F4EFE6]">Outpoured</span>
            <span className="tracking-[0.3em] uppercase text-[10px] text-[#C79A6E] pb-2">Ministries</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-xs font-body">A spiritual formation hub — closing the gap between what you believe and how you live.</p>
        </div>
        <div>
          <p className="tracking-overline text-[10px] uppercase text-[#C79A6E] mb-4">Explore</p>
          <ul className="space-y-2 text-sm font-body">
            <li><Link to="/" className="hover:text-[#F4EFE6] transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#F4EFE6] transition-colors">About</Link></li>
            <li><Link to="/portal/login" className="hover:text-[#F4EFE6] transition-colors">Login</Link></li>
          </ul>
        </div>
        <div>
          <p className="tracking-overline text-[10px] uppercase text-[#C79A6E] mb-4">The rhythm</p>
          <p className="font-serif-display text-xl text-[#F4EFE6] italic">Experience. Discover. Practice. Become.</p>
        </div>
      </div>
      <div className="border-t border-[#413d38] pt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-body">
        <span>© {new Date().getFullYear()} Outpoured Ministries</span>
        <div className="flex items-center gap-5">
          <Link to="/portal/login" data-testid="footer-member-login" className="hover:text-[#F4EFE6] transition-colors">Member Login</Link>
          <span>Jeremiah 48:11–12 · Tipped over and poured out.</span>
        </div>
      </div>
    </div>
  </footer>
);
